import { Component, inject, OnInit, signal } from '@angular/core'
import { CalloutComponent } from 'src/app/shared/components/callout/callout/callout.component'
import { PublicService } from '../../../services/public.service'
import { ActivatedRoute } from '@angular/router'
import { CompanyDetails } from '../../../interfaces/company-details.interface'
import { StripeService } from 'src/app/core/services/integrations/stripe.service'
import { CustomerDetails } from 'src/app/public/interfaces/customer-details.interface'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

@Component({
    selector: 'sf-payment-success',
    imports: [FontAwesomeModule],
    templateUrl: './payment-success.component.html',
    styleUrl: './payment-success.component.scss',
})
export class PaymentSuccessComponent implements OnInit {
    #publicService = inject(PublicService)
    #stripeService = inject(StripeService)
    #route = inject(ActivatedRoute)

    company = signal<CompanyDetails | null>(null)
    customer = signal<CustomerDetails | null>(null)

    year = new Date().getFullYear()

    success = signal<boolean>(false)
    error = signal<boolean>(false)

    ngOnInit(): void {
        this.#route.queryParamMap.subscribe((params) => {
            const companyId = params.get('companyId')
            const customerId = params.get('customerId')
            const sessionId = params.get('sessionId')

            if (companyId) {
                this.#publicService.getCompanyDetails(+companyId).subscribe({
                    next: (response) => {
                        this.company.set(response)
                    },
                    error: () => {
                        this.error.set(true)
                    },
                })
            }

            if (sessionId && customerId) {
                this.#publicService.getCustomerDetails(customerId).subscribe({
                    next: (response) => {
                        this.customer.set(response)
                    },
                    error: () => {
                        this.error.set(true)
                    },
                })

                this.#stripeService.markPaymentAsSuccessful({ sessionId, cid: customerId }).subscribe({
                    next: (response) => {
                        this.success.set(true)
                    },
                    error: () => {
                        this.error.set(true)
                    },
                })
            }
        })
    }
}
